import { render, staticRenderFns } from "./ProductFilter.vue?vue&type=template&id=0a37e0c9&scoped=true&"
import script from "./ProductFilter.vue?vue&type=script&lang=js&"
export * from "./ProductFilter.vue?vue&type=script&lang=js&"
import style0 from "./ProductFilter.vue?vue&type=style&index=0&id=0a37e0c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a37e0c9",
  null
  
)

export default component.exports